import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { LOGO } from "@/lib/brand";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim() });
      toast.success(data.message || "Iscrizione avvenuta!");
      if (!data.already) setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Iscrizione non riuscita. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border-b border-border">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h3 className="font-serif text-4xl md:text-5xl font-light leading-tight mb-3">Entra nel laboratorio</h3>
          <p className="text-muted-foreground max-w-md">Iscriviti alla newsletter: anteprime delle nuove collezioni, ispirazioni e composizioni botaniche alchemiche.</p>
        </div>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 md:justify-end" data-testid="newsletter-form">
          <Input
            type="email"
            required
            placeholder="La tua email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="sm:max-w-xs bg-background"
            data-testid="newsletter-email"
          />
          <Button type="submit" disabled={loading} className="rounded-full bg-gold hover:bg-gold/90 text-white h-11 px-7 group" data-testid="newsletter-submit">
            {loading ? "Iscrizione…" : <>Iscriviti <Send size={15} className="ml-2 transition-transform group-hover:translate-x-1" /></>}
          </Button>
        </form>
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 mt-32 border-t border-border bg-secondary/40">
      <NewsletterSignup />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={LOGO} alt="Incanti d'Estate" className="h-14 w-14 object-contain" />
            <span className="font-serif text-2xl text-gold">Incanti d'Estate</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
            Composizioni botaniche alchemiche: composizioni di fiori essiccati e stabilizzati, custodi di cristalli.
          </p>
        </div>
        <div className="text-sm space-y-3">
          <p className="uppercase tracking-widest text-xs text-muted-foreground mb-4">Naviga</p>
          <Link to="/shop" className="block hover:text-gold transition-colors">La Collezione</Link>
          <a href="/#manifesto" className="block hover:text-gold transition-colors">Il percorso</a>
          <Link to="/faq" className="block hover:text-gold transition-colors">FAQ</Link>
          <Link to="/login" className="block hover:text-gold transition-colors">Il tuo account</Link>
        </div>
        <div className="text-sm space-y-3">
          <p className="uppercase tracking-widest text-xs text-muted-foreground mb-4">Contatti</p>
          <p className="text-muted-foreground">incantidestate@gmail.com</p>
          <p className="text-muted-foreground">Spedizioni in tutta Italia e all'estero</p>
          <p className="text-muted-foreground">Pagamenti sicuri con Stripe</p>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Incanti d'Estate — Fatto a mano con incanto.
      </div>
    </footer>
  );
}
